<template>
    <div style="height: 100%">
        <!--     <b-tabs vertical id="tabsRsaPazienteAreeView" ref="tabsRsaPazienteAreeView" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items sa-tab-items-aree sa-tab-items-vertical" content-class="mt-3" class="sa-tab" style="padding-bottom: 25px" fill @input="onInputTabs"> -->
        <b-tabs id="tabsRsaAree" ref="tabsRsaAree" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <!-- </b-tabs> -->
            <b-tab v-for="areaTab in areeTabs" :key="areaTab.id" :title="areaTab.nome">
                <div class="sa-accordion-wrapper">
                    <form>
                        <div class="sa-accordion">
                            <input class="sa-accordion-input" type="radio" :name="areaTab.id + 'radio-a'" :id="areaTab.id + 'radio-a'" value="1" checked="checked" />
                            <label class="sa-accordion-label" :for="areaTab.id + 'radio-a'">
                                PIANIFICAZIONE
                                <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaPianificazione()">
                                    <i class="fas fa-plus"></i>
                                    Aggiungi
                                </b-button>
                            </label>
                            <div class="sa-accordion-content">
                                <div class="b-table-sticky-header">
                                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="pianificazioni" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                                        <template v-slot:cell(pianificazione)="{ item }">
                                            {{ getDescrizionePianificazione(item) }}
                                        </template>
                                        <template v-slot:cell(nomeAttivita)="{ item }">
                                            <!-- <span>{{ item.nomeAttivita }}</span>
                                            <span class="sa-table-span-label-primary">({{ item.dettaglio }})</span> -->
                                            <span class="sa-table-span-label-primary">{{ item.nomeAttivita }} </span>
                                            <span class="sa-table-span-label-secondary">{{ item.dettaglio }}</span>
                                        </template>
                                        <template v-slot:cell(orari)="{ item }">
                                            <span v-if="item.orari !== 'null'">
                                                {{ item.orari }}
                                            </span>
                                        </template>
                                        <template v-slot:cell(indicazioni)="{ item }">
                                            <span v-html="item.indicazioni"></span>
                                        </template>
                                        <template v-slot:cell(inizioFine)="{ item }">
                                            <span style="display: inline-block; white-space: nowrap">Inizio: {{ formatDate(item.dataInizio) }}</span
                                            ><br />
                                            <span style="display: inline-block; white-space: nowrap">Fine: {{ formatDate(item.dataFine) }}</span>
                                        </template>
                                        <template v-slot:cell(actions)="row">
                                            <b-container class="bv-example-row">
                                                <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Modifica Pianificazione" @click="onClickEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                    <b-icon icon="pencil"></b-icon>
                                                </b-button>
                                                <b-button v-if="btnPermessiElimina" v-b-tooltip.hover size="sm" variant="outline-danger no-text" title="Elimina Pianificazione" @click="onClickDelete(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                    <b-icon icon="trash"></b-icon>
                                                </b-button>
                                            </b-container>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                        <div class="sa-accordion">
                            <input class="sa-accordion-input" type="radio" :name="areaTab.id + 'radio-a'" :id="areaTab.id + 'radio-b'" value="2" />
                            <label class="sa-accordion-label" :for="areaTab.id + 'radio-b'">
                                ATTIVITA'
                                <!-- <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaAttivita()">
                                    <i class="fas fa-plus"></i>
                                    Aggiungi
                                </b-button> -->
                            </label>
                            <div slot="table-filter">
                                <b-form @submit.prevent="onSubmit">
                                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                            <label class="sa-label-data">Data Dal</label>
                                            <date-picker v-model="filtroScheduler.dataDal" format="DD-MM-YYYY" value-type="timestamp" type="timestamp"></date-picker>
                                        </b-col>
                                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                            <label class="sa-label-data">Data Al</label>
                                            <date-picker v-model="filtroScheduler.dataAl" format="DD-MM-YYYY" value-type="timestamp" type="timestamp"></date-picker>
                                        </b-col>
                                    </b-row>
                                    <b-row style="margin-top: 5px">
                                        <b-col class="sa-padding-right text-right">
                                            <b-button type="submit" variant="info">Cerca</b-button>
                                            <b-button type="reset" v-on:click="onReset" variant="danger">Reset</b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </div>
                            <div class="sa-accordion-content">
                                <!-- <p>I hope you are enjoing the video, don't forget to give your feedback in comment section</p> -->
                                <div class="b-table-sticky-header">
                                    <b-table sticky-header ref="table" stacked="lg" :tbody-tr-class="getRowClass" striped hover :items="attivitaSchedulate" :fields="fieldsAttivitaSchedulate" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table" :key="tblAttivitaSchedulateKey">
                                        <template #head(actions)="">
                                            <b-button size="sm" variant="outline-success outline-secondary-noborder" @click="onClickNuovaPianificazione()">
                                                <i class="fas fa-plus"></i>
                                                Aggiungi
                                            </b-button>
                                        </template>
                                        <template v-slot:cell(nomeAttivita)="{ item }">
                                            {{ getAttivita(item) }}
                                        </template>
                                        <template v-slot:cell(indicazioni)="{ item }">
                                            <span v-html="item.indicazioni"></span>
                                        </template>
                                        <template v-slot:cell(statoFirma)="{ item }">
                                            <b-button v-if="item.statoFirma == 'FIRMATA'" v-b-tooltip.hover.right="onHoverStatoFirma(item)" variant="outline">
                                                <font-awesome-icon icon="signature" class="text-success" />
                                            </b-button>
                                            <b-button v-else v-b-tooltip.hover.right="onHoverStatoFirma(item)" variant="outline">
                                                <font-awesome-icon icon="signature" class="text-danger" />
                                            </b-button>
                                        </template>
                                        <template v-slot:cell(actions)="row">
                                            <b-container class="bv-example-row">
                                                <template v-if="checkVisible('PROGRAMMATA', row.item, 'ESEGUI')">
                                                    <b-button :id="'btnesegui-' + row.index" v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Esegui Attività" @click="onClickEseguiAttivita(row.item, row.index, $event.target)" class="mr-1 no-text"> <b-icon icon="check"></b-icon></b-button>
                                                </template>

                                                <template v-if="checkVisible('PROGRAMMATA', row.item, 'ESEGUI_FORM')">
                                                    <b-button :id="'btneseguiform-' + row.index" v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Compila Scheda" @click="onClickEseguiAttivitaForm(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                        <i class="fas fa-tasks"></i>
                                                    </b-button>
                                                </template>
                                                <template v-if="checkVisible('PROGRAMMATA', row.item, 'NO_ESEGUI_FORM')">
                                                    <b-button :id="'btneseguiform-' + row.index" v-b-tooltip.hover size="sm" variant="outline-danger no-text" title="Compila Scheda" @click="onClickNoEseguiAttivitaForm(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                        <i class="far fa-times-circle"></i>
                                                    </b-button>
                                                </template>
                                                <b-button v-if="checkVisible('INFO', row.item)" v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Visualizza Attivita'" @click="onClickInfoAttivita(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                    <b-icon icon="info"></b-icon>
                                                </b-button>
                                                <template v-if="checkVisible('INFO', row.item, 'PRINT')">
                                                    <!--        <print-component :documentRepository="true" :idRisorsa="row.item.id" :typeButton="'small'"> </print-component> -->
                                                    <!--  <print-component :data="row" :linkPrintData="linkPrintData(row.item)" typeButton="small"></print-component>-->
                                                    <!--    <b-button variant="outline-secondary no-text" v-if="row.item.statoFirma !== 'FIRMATA'">
                                                        <b-icon icon="pencil-square"></b-icon>
                                                    </b-button> -->
                                                    <!-- <b-button v-if="row.item.statoFirma === 'FIRMATA'" size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" style="margin-right: 3px" @click="onPrintPreview(row.item)">
                                                        <b-icon icon="printer"></b-icon>
                                                        <print-component v-if="btnPrintVisible && row.item.statoFirma !== 'FIRMATA'" :jsonData="printData" :linkPrintData="linkPrintData(row.item)" typeButton="small" :firmaGrafometrica="true" :nomeFile="nomeFile" :descrizione="descrizione" :tipoDocumento="tipoDocumento" :codiceApplicativo="codiceApplicativo"></print-component>
                                                    </b-button> -->
                                                </template>
                                            </b-container>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </b-tab>
        </b-tabs>
        <b-modal :title="dynamicJsonData.titolo" ref="mdlDynamicForm" size="lg" @shown="onShownDynamicForm" @ok="onOkDynamicForm" scrollable>
            <dynamic-form ref="cmpDynamicForm" :jsonData="dynamicJsonData" :isView="isDynamicFormView"></dynamic-form>
        </b-modal>
        <rsa-aree-pianificazione-edit-component ref="cmpRsaAreePianificazioneEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-pianificazione-edit-component>
        <rsa-aree-esegui-attivita-edit-component ref="cmpRsaAreeEseguiAttivitaEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-esegui-attivita-edit-component>
        <rsa-aree-esegui-attivita-view-component ref="cmpRsaAreeEseguiAttivitaView" @afterCloseModal="onAfterCloseModalAttitvitaView"></rsa-aree-esegui-attivita-view-component>
        <modal-loading ref="cmpModalLoading"></modal-loading>
        <!--<<print-component v-show="false" ref="cmpPrint" :reportName="reportName" :jsonData="printData"></print-component>>-->
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

import DatePicker from "vue2-datepicker";
import RsaAreePianificazioneEditComponent from "./RsaAreePianificazioneEditComponent.vue";
import RsaAreeEseguiAttivitaEditComponent from "./RsaAreeEseguiAttivitaEditComponent.vue";
import RsaAreeEseguiAttivitaViewComponent from "./RsaAreeEseguiAttivitaViewComponent.vue";
import DynamicForm from "../../../utility/components/DynamicForm.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalLoading from "../../../../template/components/modal/components/ModalLoading.vue";
import Vue from "vue";
//import PrintComponent from "../../../utility/components/PrintComponent.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: {
        /* PrintComponent, */ RsaAreePianificazioneEditComponent,
        DatePicker,
        RsaAreeEseguiAttivitaEditComponent,
        RsaAreeEseguiAttivitaViewComponent,
        DynamicForm,
        ModalLoading,
        ModalError,
    },
    created() {
        /* let me = this;me.loadAree(); */
    },
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            btnPermessiElimina: false,
            tblAttivitaSchedulateKey: 0,
            dynamicJsonData: { titolo: "Qui ci va il titolo", jsonForm: [] },
            activeTabIndex: 0,
            perPage: 100,
            btnPrintVisible: true,
            pathResourcesAree: "/rsaaree",
            pathResourcesAttivita: "/rsaattivitapazienteschedulazioni",
            pathResourceAllegato: "/",
            areaSelezionata: "",
            jsonDataAccettazione: {},
            areeTabs: [],
            filtroScheduler: {
                dataDal: null,
                dataAl: null,
                idAccettazione: null,
                area: null,
            },
            pianificazioni: [],
            attivitaSchedulate: [],
            pathResourceDynamicForm: "/dynamicform",
            pathResourceDynamicFormData: null,
            isDynamicFormView: false,
            attivitaSelezionata: null,
            printData: {},
            jsonDataPrint: {},
            reportName: "",
            defaultValues: {},
            fields: [
                {
                    label: "Nome",
                    key: "nomeAttivita",
                    sortable: true,
                },
                {
                    label: "Giorni",
                    key: "pianificazione",
                    sortable: true,
                },
                {
                    label: "Orari",
                    key: "orari",
                    sortable: true,
                },
                {
                    label: "Indicazioni",
                    key: "indicazioni",
                    sortable: true,
                },
                {
                    label: "Inizio/Fine",
                    key: "inizioFine",
                    sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            fieldsAttivitaSchedulate: [
                {
                    label: "Attività",
                    key: "nomeAttivita",
                    sortable: true,
                    thStyle: "width: 15rem",
                },
                {
                    label: "Data/ora Prevista",
                    key: "dataOraPrevista",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                {
                    label: "Data/Ora Esecuzione:",
                    key: "dataOraEffettuata",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                {
                    label: "Operatore",
                    key: "cognomeNomeOperatore",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: true,
                },
                {
                    label: "Firma",
                    key: "statoFirma",
                },
                // {
                //     label: "Inizio/Fine",
                //     key: "inizioFine",
                //     sortable: true,
                // },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        getAttivita(item) {
            let returnValue = item.nomeAttivita;
            if (item.dettaglio) {
                returnValue = item.dettaglio;
            }

            return returnValue;
        },
        linkPrintData(item) {
            let path = item.pathModule ? item.pathModule : "/rsaattivitapazienteschedulazioni";
            let returnValue = path + "/printdata/" + item.rsaAttivitaPazienteBean.id;
            return returnValue;
            //
        },
        loadStampeReport(item) {
            let me = this;
            // me.printData = {};
            let path = item.pathModule && item.stato === "ESEGUITA" ? item.pathModule : "/rsaattivitapazienti";
            me.loadDataResources(path + "/printdata/" + item.rsaAttivitaPazienteBean.id, null, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = response.data.data.reportName;
            me.printData = response.data.data;
            // console.log(me.printData);

            me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            let me = this;
            let messaggio = error.response.messaggio ? error.response.messaggio : "Stampa non disponibile";
            me.$refs.cmpModalError.show(messaggio + "#");
        },
        onHoverStatoFirma(item) {
            let firma = "";
            if (item.statoFirma == "FIRMATA") {
                firma = "SCHEDA FIRMATA";
            } else {
                firma = "SCHEDA NON FIRMATA";
            }
            return firma;
        },
        checkVisible(stato, item, operazione) {
            let returnValue = false;
            if (item.stato === stato) {
                if (item.idForm && operazione === "ESEGUI_FORM") {
                    returnValue = true;
                } else if (item.idForm && operazione === "NO_ESEGUI_FORM") {
                    returnValue = true;
                } else if (!item.idForm && operazione === "ESEGUI") {
                    returnValue = true;
                }
            } else if (stato === "INFO" && item.stato !== "PROGRAMMATA") {
                returnValue = true;
            } else if (stato === "INFO" && (item.stato == "EROGATA" || item.stato == "NON EROGATA")) {
                returnValue = true;
            }

            return returnValue;
        },
        init(jsonDataAccettazione) {
            let me = this;
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.loadAree();
        },
        getRowClass(item, type) {
            let dataOraAttuale = moment(new Date());
            let dataOraPrevista = moment(new Date(item.dataOraPrevista));
            let minuti = dataOraAttuale.diff(dataOraPrevista, "minute");
            if (item.stato === "NON ESEGUITA") {
                return "sa-table-row-danger";
            } else if (minuti > 15 && type === "row") {
                return "sa-table-row-warning";
            } else {
                return null;
            }
        },
        loadAree() {
            // let me = this;
            // me.areeTabs = [
            //     { id: "1", nome: "CURA DELLA PERSONA" },
            //     { id: "2a", nome: "AREA DI PROVA" },
            // ];
            // me.loadAttivita();
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAree;

            axios
                .get(link)
                .then((response) => {
                    me.areeTabs = response.data.data.list;
                    me.areaSelezionata = me.areeTabs[0].nome;
                    me.filtroScheduler.dataDal = new Date().getTime();
                    me.loadDataScheduler();
                    me.loadAttivita();
                })
                .catch(() => {});
        },
        loadAttivita() {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAttivita;
            let filtro = {
                idAccettazione: me.jsonDataAccettazione.id,
                area: me.areaSelezionata,
            };
            me.btnPermessiElimina = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "rsaattivita", 8);
            console.log(UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "rsaattivita", 8));

            axios
                .get(link, { params: filtro })
                .then((response) => {
                    me.pianificazioni = response.data.data.list;
                })
                .catch(() => {});
        },
        onInputTabs(e) {
            let me = this;
            // let area = this.areeTabs[e];
            me.areaSelezionata = this.areeTabs[e].nome;
            me.loadAttivita();
            me.filtroScheduler.dataDal = new Date().getTime();
            me.loadDataScheduler();
            me.tblAttivitaSchedulateKey++;
        },
        onClickNuovaPianificazione() {
            let me = this;
            // let area = me.areeTabs.reduce((acc, currentValue) => rec.nome === me.areaSelezionata);
            let area = me.areeTabs.reduce((row, currentRow) => (row.nome === me.areaSelezionata ? row : currentRow));

            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                me.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            }
            me.$refs.cmpRsaAreePianificazioneEditComponent.edit(
                {
                    id: null,
                    nomeAttivita: null,
                    dataInizio: new Date().getTime(),
                    dataFine: null,
                    listaOrari: [{ dataInizio: new Date().getTime(), giorni: null, orari: null }],
                    idAccettazione: me.jsonDataAccettazione.id,
                    idPaziente: me.jsonDataAccettazione.accettazioneAnagrafica.id,
                    area: me.areaSelezionata,
                    dettaglio: "",
                },
                area
            );
        },
        onClickNuovaAttivita() {},
        onAfterSaveRequestRsaAreePianificazioneComponent() {
            let me = this;
            me.loadDataScheduler();
            me.loadAttivita();
        },
        onAfterCloseModalAttitvitaView() {
            let me = this;
            me.loadDataScheduler();
            me.loadAttivita();
        },
        onClickEdit(item) {
            let me = this;
            let area = me.areeTabs.reduce((row, currentRow) => (row.nome === me.areaSelezionata ? row : currentRow));
            me.$refs.cmpRsaAreePianificazioneEditComponent.edit(item, area);
        },
        onClickDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Titolo",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        console.log(item);
                        let link = process.env.VUE_APP_PATH_API + me.pathResourcesAttivita + "/" + item.id;
                        UtilityMixin.methods.restCallDelete(link, me.deleteSuccess, me.deleteError);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteSuccess(response) {
            let me = this;
            me.$bvToast.toast(response.data.messaggio, {
                title: "",
                variant: "success",
                solid: true,
            });
            me.loadAttivita();
        },
        deleteError(error) {
            let me = this;
            console.log(error.response.data.messaggio);

            me.$emit("afterLoadData");
            me.$refs.cmpModalError.show(error.response.data.messaggio + "#");
        },
        onSubmit() {
            let me = this;
            me.loadDataScheduler();
        },
        onReset() {
            let me = this;
            me.attivitaSchedulate = [];
            me.filtroScheduler = {
                dataDal: new Date().getTime(),
                dataAl: null,
                idAccettazione: me.jsonDataAccettazione.id,
                area: me.jsonDataAccettazione.areaSelezionata,
            };
            me.loadDataScheduler();
        },
        loadDataScheduler() {
            let me = this;
            me.attivitaSchedulate = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAttivita + "/scheduler";
            me.filtroScheduler.idAccettazione = me.jsonDataAccettazione.id;
            me.filtroScheduler.area = me.areaSelezionata;
            axios
                .get(link, { params: me.filtroScheduler })
                .then((response) => {
                    me.attivitaSchedulate = response.data.data;
                })
                .catch((error) => {
                    // me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        onClickEseguiAttivita(item) {
            let me = this;
            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                me.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            }
            me.attivitaSelezionata = item;
            if (item.rsaAttivitaPazienteBean === null) {
                item.dataOraEffettuata = new Date().getTime();
            }
            me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(item);
        },
        onClickNoEseguiAttivitaForm(item) {
            let me = this;
            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                me.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            }
            me.attivitaSelezionata = item;
            if (item.rsaAttivitaPazienteBean === null) {
                item.dataOraEffettuata = new Date().getTime();
            }
            me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(item, "NON ESEGUITA");
        },
        onClickEseguiAttivitaForm(item) {
            let me = this;
            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                me.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            }
            me.$refs.cmpModalLoading.show();
            me.isDynamicFormView = false;
            me.attivitaSelezionata = item;
            UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + item.idForm, {}, me.loadDynamicFormSuccess, me.loadDynamicFormError);
        },
        loadDynamicFormSuccess(response) {
            let me = this;
            me.$refs.cmpModalLoading.close();
            let dynamicJsonData = response.data.data;
            dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
            me.dynamicJsonData = dynamicJsonData;
            me.pathResourceDynamicFormData = dynamicJsonData.pathModule;
            me.getJsonForm(me.dynamicJsonData.jsonForm);
            me.$refs.mdlDynamicForm.show();
        },
        loadDynamicFormError(error) {
            console.log(error);
        },
        onClickInfoAttivita(item) {
            let me = this;
            if (item.idForm && item.stato === "ESEGUITA") {
                me.attivitaSelezionata = item;
                me.loadDinamicFormView(item.idForm);
            } else {
                me.$refs.cmpRsaAreeEseguiAttivitaView.add(item);
            }
        },
        loadDinamicFormView(idForm) {
            let me = this;
            me.$refs.cmpModalLoading.show();
            UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + idForm, {}, me.loadDinamicFormViewSuccess, me.loadDinamicFormViewError);
        },
        loadDinamicFormViewSuccess(response) {
            let me = this;
            if (response.data.data.pathModule) {
                me.$refs.cmpModalLoading.close();
                let dynamicJsonData = response.data.data;
                dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
                me.dynamicJsonData = dynamicJsonData;
                let link = process.env.VUE_APP_PATH_API + response.data.data.pathModule + "/attivita/" + me.attivitaSelezionata.rsaAttivitaPazienteBean.id;
                axios
                    .get(link)
                    .then((response) => {
                        me.defaultValues = response.data.data;
                        me.defaultValues.ospite = me.jsonDataAccettazione.accettazioneAnagrafica.nome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.cognome;
                        me.defaultValues.educatore = me.utente.firstname + " " + me.utente.lastname;
                        me.defaultValues.numero = me.jsonDataAccettazione.numero;
                        me.defaultValues.dataNascita = me.formatDate(me.jsonDataAccettazione.accettazioneAnagrafica.dataNascita);
                        me.isDynamicFormView = true;
                        me.$refs.mdlDynamicForm.show();
                    })
                    .catch((error) => {
                        me.$emit("afterSaveRequest");
                        console.log(error);
                        let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                        if (!messaggio) {
                            messaggio = error.message;
                        }
                        console.log(messaggio);
                        this.$bvModal
                            .msgBoxOk(messaggio, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerBgVariant: "danger",
                                centered: true,
                            })
                            .then((value) => {
                                console.log(value);
                            })
                            .catch(() => {
                                // An error occurred
                            });
                        // me.$bvModal.msgBoxOk(messaggio, {
                        // 	title: "ATTENZIONE",
                        // 	size: "sm",
                        // 	okVariant: "outline-danger",
                        // 	headerBgVariant: "danger",
                        // 	centered: true,
                        // });
                    });
            } else {
                me.$bvModal.msgBoxOk("Path del modulo non configurato", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerBgVariant: "danger",
                    centered: true,
                });
            }
        },
        loadDinamicFormViewError(error) {
            console.log(error);
        },
        getDescrizionePianificazione(item) {
            let returnValue = "";
            let giorni = [];
            if (item.listaOrari.length > 0) {
                let detaglio = item.listaOrari[0];
                switch (detaglio.tipo) {
                    case "TURNI":
                        for (let giorno of detaglio.giorni.split(",")) {
                            let dayOfWeek = this.getDayOfWeek(giorno);
                            giorni.push(dayOfWeek);
                        }
                        break;
                    case "ORARIO":
                        for (let giorno of detaglio.giorni.split(",")) {
                            let dayOfWeek = this.getDayOfWeek(giorno);
                            giorni.push(dayOfWeek);
                        }
                        break;
                    case "ORE ALTERNATE":
                        for (let giorno of detaglio.giorni.split(",")) {
                            let dayOfWeek = this.getDayOfWeek(giorno);
                            giorni.push(dayOfWeek);
                        }
                        break;
                    case "GIORNI ALTERNATI":
                        giorni.push("Ogni " + detaglio.giorni + " giorno/i");
                        break;
                    case "GIORNI MESE":
                        giorni.push("Nei giorni " + detaglio.giorni + " del mese");
                        break;
                }
            }
            returnValue = giorni.join(", ");
            return returnValue;
        },
        onShownDynamicForm() {
            let me = this;
            me.$refs.cmpDynamicForm.setForm(me.defaultValues);
        },
        onOkDynamicForm(bvModalEvent) {
            let me = this;
            if (me.isDynamicFormView) {
                me.$refs.mdlDynamicForm.hide();
            } else {
                let responseJsonData = this.$refs.cmpDynamicForm.getJsonData();
                responseJsonData.idAccettazione = me.attivitaSelezionata.idAccettazione;
                responseJsonData.idPaziente = me.attivitaSelezionata.idPaziente;
                responseJsonData.dataOraPrevista = me.attivitaSelezionata.dataOraPrevista;
                responseJsonData.dataOraEffettuata = me.attivitaSelezionata.dataOra;
                responseJsonData.dataOra = me.attivitaSelezionata.dataOra;
                responseJsonData.idRsaAttivitaPazienteSchedulazione = me.attivitaSelezionata.idRsaAttivitaPazienteSchedulazione;
                responseJsonData.nomeAttivita = me.attivitaSelezionata.nomeAttivita;
                responseJsonData.dettaglio = me.attivitaSelezionata.dettaglio;
                responseJsonData.indicazioni = me.attivitaSelezionata.indicazioni;
                responseJsonData.idAttivita = me.attivitaSelezionata.idAttivita;
                responseJsonData.idForm = me.dynamicJsonData.id;
                responseJsonData.dataOra = new Date().getTime();
                responseJsonData.note = " ";
                delete responseJsonData.ospite;
                delete responseJsonData.dataNascita;
                delete responseJsonData.educatore;
                delete responseJsonData.numero;
                //delete responseJsonData.dataOra;
                bvModalEvent.preventDefault();
                me.creaAttivita(responseJsonData);
            }
        },
        creaAttivita(responseJsonData) {
            let me = this;
            me.$refs.cmpModalLoading.show();
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDynamicFormData;

            axios
                .post(link, responseJsonData)
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.loadDataScheduler();
                    me.loadAttivita();
                    me.$refs.mdlDynamicForm.hide();
                    me.$refs.cmpModalLoading.close();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = "Errore non gestito";
                    if (error.response) {
                        if (error.response.data.messaggio) {
                            messaggio = error.response.data.messaggio;
                        } else {
                            messaggio = error.response.data;
                        }
                    }
                    this.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerBgVariant: "danger",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                    me.$refs.cmpModalLoading.close();
                });
        },
        getJsonForm(jsonForm) {
            let me = this;
            me.defaultValues = {};
            jsonForm.forEach((element) => {
                switch (element.type) {
                    case "select":
                        me.defaultValues[element.modelName] = null;
                        break;
                    case "datepicker":
                        me.defaultValues[element.modelName] = new Date().getTime();
                        break;
                }
            });
            me.defaultValues.ospite = me.jsonDataAccettazione.accettazioneAnagrafica.nome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.cognome;
            // me.defaultValues.educatore = me.utente.firstname + " " + me.utente.lastname;
            me.defaultValues.operatore = me.utente.firstname + " " + me.utente.lastname;
            me.defaultValues.numero = me.jsonDataAccettazione.numero;
            me.defaultValues.dataNascita = this.formatDate(me.jsonDataAccettazione.accettazioneAnagrafica.dataNascita);
        },
    },
};
</script>
